import { observable } from "mobx";
import EnforcementUserType from "./enforcementUserType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EnforcementTabletUserResponse {
  /**
   * User ID.
   */
  id!: string;

  /**
   * User personal code.
   */
  @observable
  code!: string;

  @observable
  userType!: EnforcementUserType;

  /**
   * Indicates if user is manager.
   */
  @observable
  isManager!: boolean;
}
